import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export default function NotFoundRedirect() {
  const nav = useNavigate();
  useEffect(() => {
    nav({ to: "/" });
  }, []);
  return null;
}
